import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2021/1/19 下午3:36
 */ import { Navigate, useLocation } from "react-router-dom";
import { equals, isEmpty, isNil, not } from "ramda";
import { Loading, LoadingError } from "@/components/Loading";
import { useBoolean } from "@/hooks";
import { useStore, useStoreValue } from "@/hooks";
import { UserInfoState, findUserInfo, LoginInfoState } from "@/store/globalStore";
import { setBpmInit } from "@/utils";
export function Interceptor(param) {
    let { route } = param;
    // 是否查询用户信息失败
    const [loadingError, { setTrue, setFalse }] = useBoolean(false);
    const loginInfo = useStoreValue(LoginInfoState);
    const [userInfo, setUserInfo] = useStore(UserInfoState);
    const location = useLocation();
    if (!isNil(route.redirect) && equals(location.pathname, route.path)) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: route.redirect
        });
    }
    // 登录权限校验
    if (not(route.notLogin)) {
        if (isNil(loginInfo.accessToken) || isEmpty(loginInfo.accessToken)) {
            const redirect = location.pathname + "" + location.search;
            return /*#__PURE__*/ _jsx(Navigate, {
                to: "/login?redirect_uri=" + encodeURIComponent(redirect)
            });
        }
        // 请求用户基本数据
        if (isNil(userInfo) || isEmpty(userInfo)) {
            findUserInfo().then((res)=>{
                if (res) {
                    setUserInfo(res);
                    setFalse();
                    setBpmInit();
                }
            }).catch(()=>{
                setTrue();
            });
            return loadingError ? /*#__PURE__*/ _jsx(LoadingError, {}) : /*#__PURE__*/ _jsx(Loading, {});
        }
    }
    const RenderCom = route.component;
    return /*#__PURE__*/ _jsx(RenderCom, {
        userInfo: userInfo,
        name: route.name,
        routes: route.children
    });
}
